<template>
  <v-dialog v-model="show" max-width="800" persistent>

    <v-card class="trigger-modal pa-3">
      <v-card-title class="headline">
        <span>Triggers para <strong>{{ sourceChannelName }}</strong></span>
      </v-card-title>

      <v-card-text>

        <v-container fluid :class="{'border-radius-10 elevation-1' : true, 'pt-2' : editing }">
          <v-layout row wrap class="mb-4">
            <v-flex xs11 class="d-flex align-center">
              <strong>{{ editing ? 'Editar' : 'Agregar nuevo' }} trigger</strong>
            </v-flex>
            <v-flex xs1 v-if="editing" class="text-xs-right">
              <v-btn icon small @click="stopEditing" :disabled="disableButtons"><v-icon>close</v-icon></v-btn>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="mb-2">
            <v-flex xs5 class="pr-2">
              <label class="text-body-1">Cuando el resultado sea</label>
              <v-select
                v-model="triggerForm.status_id"
                :items="channelStatuses"
                color="black"
                class="elevation-0 border-radius-10"
                label="Seleccionar un estatus"
                item-text="name"
                item-value="id"
                autocomplete
                outline
                solo
              />
            </v-flex>
            <v-flex xs5 class="px-2">
              <label class="text-body-1">Enviar un</label>
              <v-select
                v-model="triggerForm.channel_id"
                :items="availableChannels"
                color="black"
                class="elevation-0 border-radius-10"
                label="Selecciona un canal"
                item-text="title"
                item-value="id"
                outline
                solo
              />
            </v-flex>
            <v-flex xs2>
              <div class="d-flex justify-end align-end text-xs-right" style="height: 100%;">
                <v-btn v-if="!editing" class="k-orange-linear" :disabled="!isFormValid || duplicatedTrigger || disableButtons" @click="addTrigger"><v-icon>add</v-icon> Agregar</v-btn>
                <v-btn v-else class="k-orange-linear" :disabled="!isFormValid || duplicatedTrigger || disableButtons" @click="updateTrigger"><v-icon>save</v-icon> Guardar</v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-layout v-if="triggerForm.channel_id" row wrap class="mt-3">
            <v-flex xs12>
              <label class="text-body-1">Plantilla</label>
              <!-- IVR / Bot: sin slots (slots vacíos rompen Vuetify 1) -->
              <v-select
                v-if="showTemplateSelector && triggerForm.channel_id !== 7"
                v-model="triggerForm.template_id"
                :items="templatesList"
                color="black"
                class="elevation-0 border-radius-10"
                label="Seleccionar plantilla"
                item-text="name"
                item-value="id"
                autocomplete
                outline
                solo
              />

              <!-- WhatsApp: chips de status en selection e item -->
              <v-select
                v-if="triggerForm.channel_id === 7 && !collyRelease.whatsapp"
                v-model="triggerForm.template_id"
                :items="templatesList"
                color="black"
                class="elevation-0 border-radius-10"
                label="Seleccionar plantilla"
                item-text="name"
                item-value="id"
                autocomplete
                outline
                solo
              >
                <template slot="selection" slot-scope="data">
                  <span class="mr-2">{{ data.item.name }}</span>
                  <v-chip
                    v-if="data.item && !data.item.isApproved"
                    small
                    :color="data.item.statusColor"
                    :text-color="data.item.statusTextColor"
                  >
                    {{ data.item.statusLabel }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip
                      small
                      :color="data.item.statusColor"
                      :text-color="data.item.statusTextColor"
                    >
                      {{ data.item.statusLabel }}
                    </v-chip>
                  </v-list-tile-action>
                </template>
              </v-select>

              <!-- WhatsApp con release: plantilla y remitente colly en el diálogo de WhatsApp -->
              <v-text-field
                v-if="triggerForm.channel_id === 7 && collyRelease.whatsapp"
                :label="!triggerForm.colly_template_id ? 'Seleccionar plantilla' : 'Ver plantilla'"
                append-icon="fas fa-edit"
                @click="showWhatsappDialog = true"
                class="elevation-0 border-radius-10 cursor-pointer"
                color="black"
                outline
                readonly
                solo
                />

              <v-text-field
                v-if="!showTemplateSelector"
                :label="!triggerForm.text && !triggerForm.colly_template_id ? 'Crear plantilla' : 'Ver plantilla'"
                append-icon="fas fa-edit"
                @click="showTemplateEditor = true"
                class="elevation-0 border-radius-10 cursor-pointer"
                color="black"
                outline
                readonly
                solo
                />

              <p
                v-if="triggerForm.channel_id === 7 && !collyRelease.whatsapp && selectedTriggerTemplate && !selectedTriggerTemplate.isApproved"
                class="mb-0 mt-2 red--text text--darken-2"
              >
                La plantilla seleccionada no está aprobada. Elija otra plantilla para guardar.
              </p>

            </v-flex>
          </v-layout>

          <v-layout v-if="triggerForm.channel_id" row wrap class="mt-4">
            <v-flex xs12>
              <label class="text-body-1">Agregar condición</label>
            </v-flex>
            <v-flex
              v-if="triggerForm.conditions.length === 0"
              xs12
              class="mt-2 d-flex justify-start align-center"
            >
              <v-btn
                type="button"
                depressed
                round
                class="k-orange-linear add-condition-btn ma-0"
                :disabled="disableButtons"
                @click="addConditionRow"
              >
                <v-icon small class="white--text">fas fa-plus</v-icon>
              </v-btn>
            </v-flex>

            <v-layout
              v-for="(condition, conditionIndex) in triggerForm.conditions"
              :key="'trigger-condition-' + conditionIndex"
              row
              wrap
              class="mt-3 align-start condition-editor-row"
            >
              <v-flex xs12 sm11 class="condition-editor-fields pr-2">
                <v-layout row wrap>
                  <v-flex xs12 sm4 md4 class="pr-2">
                    <v-select
                      v-model="condition.field"
                      :items="conditionFieldsForRow(conditionIndex)"
                      color="black"
                      class="elevation-0 border-radius-10 condition-type-select condition-select-truncate"
                      label="Condición"
                      item-text="text"
                      item-value="value"
                      outline
                      solo
                      clearable
                      @change="onConditionRowFieldChange(conditionIndex)"
                    />
                  </v-flex>
                  <v-flex
                    :key="'trigger-condition-operator-' + conditionIndex + '-' + conditionFieldKey(condition.field)"
                    xs12
                    sm3
                    md3
                    class="px-2"
                  >
                    <v-text-field
                      v-if="isTimeWindowConditionRow(condition)"
                      :value="'Mayor o igual que'"
                      label="Operador"
                      readonly
                      solo
                      outline
                      color="black"
                      class="elevation-0 border-radius-10 condition-operator-select condition-select-truncate"
                    />
                    <v-select
                      v-if="!isTimeWindowConditionRow(condition)"
                      v-model="condition.operator"
                      :items="triggerConditionOperators"
                      color="black"
                      class="elevation-0 border-radius-10 condition-operator-select condition-select-truncate"
                      label="Operador"
                      item-text="text"
                      item-value="value"
                      outline
                      solo
                      clearable
                    />
                  </v-flex>
                  <v-flex xs12 sm4 md4 class="pl-2">
                    <v-text-field
                      v-model.number="condition.value"
                      type="number"
                      min="0"
                      step="1"
                      color="black"
                      class="elevation-0 border-radius-10 condition-value-field"
                      label="Valor"
                      :hint="conditionValueHint(condition.field)"
                      :persistent-hint="conditionRowHasField(condition)"
                      outline
                      solo
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm1 class="condition-trash-col d-flex justify-end justify-sm-end align-start pt-1">
                <v-btn
                  icon
                  small
                  class="ma-0 condition-trash-btn"
                  :disabled="disableButtons"
                  title="Quitar condición"
                  @mouseenter.native="conditionTrashHoverIndex = conditionIndex"
                  @mouseleave.native="conditionTrashHoverIndex = null"
                  @click="removeConditionRow(conditionIndex)"
                >
                  <v-icon
                    small
                    class="condition-trash-icon"
                    :class="conditionTrashIconClassForRow(conditionIndex)"
                  >
                    fas fa-trash-alt
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-flex
              v-if="canAddAnotherCondition"
              xs12
              class="mt-2 d-flex justify-start align-center"
            >
              <v-btn
                type="button"
                depressed
                round
                class="k-orange-linear add-condition-btn ma-0"
                :disabled="disableButtons"
                @click="addConditionRow"
              >
                <v-icon small class="white--text">fas fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout v-if="triggerForm.channel_id" row wrap class="mt-4">
            <v-flex xs12>
              <label class="text-body-1 d-block mb-2">
                Cuando se dispare el evento, ¿cómo debe enviarse esta gestión?
              </label>
              <v-radio-group
                v-model="triggerForm.force_delivery"
                :hide-details="true"
                :disabled="disableButtons"
                class="ma-0 pt-0"
              >
                <v-radio
                  :value="1"
                  color="green"
                  label="Enviarla siempre, aunque el cliente ya haya sido contactado hoy."
                />
                <v-radio
                  :value="0"
                  color="green"
                  label="Solo enviarla si está dentro de la ventana de tiempo configurada."
                />
              </v-radio-group>
            </v-flex>
          </v-layout>

          <small v-if="duplicatedTrigger" class="text--red">
            Ya existe un trigger para este canal y estatus
          </small>
        </v-container>

        <v-layout row wrap class="mt-4 mb-3">
          <v-flex xs12>
            <strong>Triggers activos ({{ triggers.length }})</strong>
          </v-flex>
        </v-layout>

        <v-layout v-for="trigger in triggers" :key="trigger.id" row wrap class="ma-0 mb-3 pa-3 elevation-1 border-radius-10">
          <v-flex xs4 class="d-flex align-center">
            <div>
              <v-avatar size="35" class="k-orange-linear mr-2">
                <v-icon class="white--text" small>{{ getChannelById(trigger.channel_id, 'icon') }}</v-icon>
              </v-avatar>
              <strong>{{ getChannelById(trigger.channel_id, 'title') }}</strong>
            </div>
          </v-flex>
          <v-flex xs6 class="d-flex align-center">
            Trigger para:
            <strong class="ml-2">
              {{ showStatusName(trigger.status_id) }}
            </strong>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn icon small :class="{ 'text-success' : editing && editingTriggerId === trigger.id }" @click="editTrigger(trigger)" :disabled="disableButtons || editing"><v-icon>edit</v-icon></v-btn>
            <v-btn icon small color="red" class="text-white" @click="removeTrigger(trigger.id)" :disabled="disableButtons"><v-icon small>delete</v-icon></v-btn>
          </v-flex>
        </v-layout>

      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn :disabled="disableButtons || editing" flat @click="$emit('update:show', false)">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>

    <template-editor
      :show="showTemplateEditor"
      :show-un-used-fields="false"
      :channel="getChannelById(triggerForm.channel_id, 'name') || 'sms'"
      :template="triggerFormTemplate"
      :append-vars="templateVars"
      :filter="triggerEditorFilter"
      :activate-check="false"
      :is-in-release="true"
      :is-new-workflow="false"
      :show-unused-fields="false"
      validation-email-scope="triggers"
      @close="showTemplateEditor = false"
      @save="saveTemplate"
    />

    <whatsapp-templates-dialog
      :show="showWhatsappDialog"
      :workflow-filter="{
        colly_whatsapp_template_id: triggerForm.colly_template_id,
        colly_whatsapp_sender_id: triggerForm.sender_id,
      }"
      :is-payment-type="false"
      :is-in-release="false"
      :is-new-workflow="false"
      @save="saveWhatsappTemplate"
      @close="showWhatsappDialog = false"
    />

  </v-dialog>
</template>

<script>
import _ from 'lodash';

import EventBus from '@/event-bus';
import statusMixin from '@/mixins/status';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import { fetchWhatsappTemplatesForSelect } from '@/mixins/whatsappTemplateSelect';
import TemplateEditor from '@/components/Templates/Index.vue';
import WhatsappTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/WhatsappTemplates';

/** Payload API: `conditions: { items: [{ field, operator, value }] }` */
const TRIGGER_CONDITION_FIELD = {
  timeWindow: 'time_window',
  callDuration: 'call_duration',
};

/** Único operador permitido para ventana de tiempo (`time_window`). */
const TIME_WINDOW_OPERATOR = '>=';

const TRIGGER_CONDITION_OPERATORS = [
  { text: 'Mayor o igual que', value: '>=' },
  { text: 'Menor o igual que', value: '<=' },
];

const TRIGGER_CONDITION_OPERATOR_VALUES = TRIGGER_CONDITION_OPERATORS.map(o => o.value);

/** `field` tal cual en API y formulario: solo `time_window` y `call_duration`. */
function canonicalTriggerConditionField(field) {
  if (field === undefined || field === null || field === '') {
    return null;
  }
  if (typeof field === 'object' && field !== null && 'value' in field) {
    return canonicalTriggerConditionField(field.value);
  }
  return field;
}

function normalizedOperatorForConditionField(field, operatorFromApi) {
  if (field === TRIGGER_CONDITION_FIELD.timeWindow) {
    return TIME_WINDOW_OPERATOR;
  }
  return TRIGGER_CONDITION_OPERATOR_VALUES.includes(operatorFromApi) ? operatorFromApi : '>=';
}

export default {
  name: 'TriggersModal',
  components: {
    TemplateEditor,
    WhatsappTemplatesDialog,
  },
  mixins: [
    statusMixin,
    channelsMixin,
    filtersMixin,
  ],
  inject: {
    collyRelease: { default: () => ({}) },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    sourceChannel: {
      type: String,
      required: true,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const emptyTriggerForm = {
      channel_id: null,
      status_id:  null,

      // BOT, IVR and WHATSAPP
      template_id: null,

      // SMS
      sms_enable_short_url: true,

      // Email fields
      subject: '',
      company_email_id: null,

      // Works for sms and email
      text: '',

      // Plantilla y remitente colly (sms, email y whatsapp); remitente null = por defecto.
      colly_template_id: null,
      sender_id: null,

      // Switch "Forzar envío". 1 = la gestión del trigger sale siempre,
      // 0 = respeta las reglas de contacto del cliente.
      force_delivery: 0,
    };
    return {
      triggers:           [],
      openPanel:          [],
      /**
       * `conditions` siempre es un array nuevo al resetear (no va en emptyTriggerForm para no compartir referencia).
       * Cada ítem: { field, operator, value } → API `conditions.items`.
       */
      triggerForm:        { ...emptyTriggerForm, conditions: [] },
      templatesList:      [],
      disableButtons:     false,
      channelStatuses:    [],
      editingTriggerId:   null,
      emptyTriggerForm,
      showTemplateEditor: false,
      showWhatsappDialog: false,
      conditionTrashHoverIndex: null,
      triggerConditionOperators: TRIGGER_CONDITION_OPERATORS,
      templatesCache:     {},
    };
  },
  computed: {
    /** Lo mínimo para que el editor use plantillas colly (sin claves de promesa de pago). */
    triggerEditorFilter() {
      const channel = this.getChannelById(this.triggerForm.channel_id, 'name');
      return {
        id: this.filter.id,
        [`colly_${channel}_template_id`]: this.triggerForm.colly_template_id,
        [`colly_${channel}_sender_id`]: this.triggerForm.sender_id,
      };
    },
    triggerFormTemplate() {
      if (this.triggerForm.channel_id !== 1 && this.triggerForm.channel_id !== 2) {
        return {};
      }

      if (this.triggerForm.channel_id === 2) {
        return {
          text:                 this.triggerForm.text,
          sms_enable_short_url: this.triggerForm.sms_enable_short_url,
        };
      }

      return {
        text:             this.triggerForm.text,
        subject:          this.triggerForm.subject,
        company_email_id: this.triggerForm.company_email_id,
      };
    },
    duplicatedTrigger() {
      if (!this.triggerForm.channel_id || !this.triggerForm.status_id) {
        return false;
      }

      return this.triggers.some((trigger) => {
        let validation = trigger.channel_id === this.triggerForm.channel_id && trigger.status_id === this.triggerForm.status_id;

        if (this.editing) {
          validation = validation && this.editingTriggerId !== trigger.id;
        }

        return validation;
      });
    },
    editing() {
      return !!this.editingTriggerId;
    },
    editingTrigger() {
      if (!this.editing) {
        return null;
      }

      return this.triggers.find(trigger => trigger.id === this.editingTriggerId);
    },
    availableChannels() {
      const channels = [
        { id: 3, name: 'ivr', title: 'Ivr', icon: 'fas fa-phone' },
        { id: 4, name: 'bot', title: 'Bot', icon: 'fas fa-robot' },
        { id: 7, name: 'whatsapp', title: 'WhatsApp', icon: 'fab fa-whatsapp' },
        { id: 2, name: 'sms', title: 'SMS', icon: 'fas fa-sms' },
        { id: 1, name: 'email', title: 'Email', icon: 'fas fa-envelope' },
      ];

      return channels.filter(item => item.id !== this.sourceChannelId);
    },
    /**
     * Lista completa de canales (sin filtrar) para mostrar íconos y nombres
     * en el listado de triggers activos. `availableChannels` excluye el canal
     * de origen, lo cual rompe el display si un trigger apunta a ese canal.
     */
    allChannels() {
      return [
        { id: 3, name: 'ivr', title: 'Ivr', icon: 'fas fa-phone' },
        { id: 4, name: 'bot', title: 'Bot', icon: 'fas fa-robot' },
        { id: 5, name: 'human', title: 'Humano', icon: 'fas fa-user' },
        { id: 7, name: 'whatsapp', title: 'WhatsApp', icon: 'fab fa-whatsapp' },
        { id: 2, name: 'sms', title: 'SMS', icon: 'fas fa-sms' },
        { id: 1, name: 'email', title: 'Email', icon: 'fas fa-envelope' },
      ];
    },
    /**
     * Id del canal de origen del filtro (ej. human=5). No puede resolverse con availableChannels:
     * esa lista solo tiene destinos (ivr, bot, whatsapp, sms, email).
     */
    sourceChannelId() {
      const name = (this.sourceChannel || '').toLowerCase();
      const ch = this.channels.find(c => c.name === name);
      return ch ? ch.id : null;
    },
    sourceChannelName() {
      return this.sourceChannel.toLowerCase();
    },
    selectedTriggerTemplate() {
      return this.templatesList.find(template => template.id === this.triggerForm.template_id) || null;
    },
    isFormValid() {
      let validation = this.triggerForm.channel_id && this.triggerForm.status_id;

      if (
        this.triggerForm.channel_id === 3
        || this.triggerForm.channel_id === 4
      ) {
        validation = validation && this.templatesList.length > 0 && this.triggerForm.template_id;
      }

      if (this.triggerForm.channel_id === 7 && this.collyRelease.whatsapp) {
        validation = validation && this.triggerForm.colly_template_id;
      }

      if (this.triggerForm.channel_id === 7 && !this.collyRelease.whatsapp) {
        validation = validation
          && this.templatesList.length > 0
          && this.triggerForm.template_id
          && this.selectedTriggerTemplate
          && this.selectedTriggerTemplate.isApproved;
      }

      if (this.triggerForm.channel_id === 2 || this.triggerForm.channel_id === 1) {
        validation = validation && (this.triggerForm.colly_template_id || this.triggerForm.text);
      }

      if (this.triggerForm.channel_id === 1 && !this.triggerForm.colly_template_id) {
        validation = validation && this.triggerForm.subject && this.triggerForm.company_email_id && this.triggerForm.text;
      }

      const conds = this.triggerForm.conditions || [];
      for (let i = 0; i < conds.length; i += 1) {
        const c = conds[i];
        if (!this.isConditionRowValid(c)) {
          validation = false;
          break;
        }
      }

      return validation;
    },
    showTemplateSelector() {
      return [3, 4, 7].includes(this.triggerForm.channel_id);
    },
    /**
     * Campos `field` permitidos: ventana de tiempo siempre; duración de llamada solo si el canal
     * origen es IVR, Bot u Humano (ids 3, 4, 5).
     */
    allConditionFieldOptionsForChannel() {
      return this.getConditionFieldOptionsForChannelId();
    },
    maxConditionsForCurrentChannel() {
      return this.allConditionFieldOptionsForChannel.length;
    },
    /**
     * Segundo +: solo si hay filas, todas ya tienen tipo elegido y aún cabe otro tipo distinto.
     * (Origen IVR/Bot/Humano: hasta 2 tipos; otros orígenes: 1 tipo — no se muestra segundo +.)
     */
    canAddAnotherCondition() {
      if (!this.triggerForm.channel_id) {
        return false;
      }
      const n = this.triggerForm.conditions.length;
      if (n === 0 || n >= this.maxConditionsForCurrentChannel) {
        return false;
      }
      const everyRowHasField = this.triggerForm.conditions.every(c => !!c.field);
      return everyRowHasField;
    },
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.conditionTrashHoverIndex = null;
        this.templatesCache = {};
        return;
      }

      this.disableButtons = false;
      this.resetForm();
      this.fetchChannelStatuses();
      this.fetchAllTemplates();

      const filterTriggers = this.filter.triggers || [];
      if (filterTriggers.length > 0) {
        this.triggers = filterTriggers.map(trigger => ({
          id:                   trigger.id,
          text:                 (trigger.template || {})[trigger.destination_channel_id === 2 ? 'sms' : 'email'] || '',
          subject:              (trigger.template || {}).subject || '',
          status_id:            trigger.source_status_id,
          channel_id:           trigger.destination_channel_id,
          template_id:          trigger.template_id,
          company_email_id:     (trigger.template || {}).company_email_id || null,
          sms_enable_short_url: (trigger.template || {}).sms_enable_short_url,
          conditions:           this.normalizeConditionsFromTrigger(trigger),
          force_delivery:  this.normalizeForceDelivery(trigger.force_delivery),
          colly_template_id: trigger.colly_template_id || null,
          sender_id: trigger.sender_id || null,
        }));
      } else {
        this.triggers = [];
      }
    },
    'triggerForm.channel_id': {
      handler(newVal) {
        // If channel changed of a existing trigger, reset template
        if (this.editing && (this.editingTrigger || {}).channel_id !== newVal) {
          this.triggerForm.text = '';
          this.triggerForm.subject = '';
          this.triggerForm.template_id = null;
          this.triggerForm.company_email_id = null;
          this.triggerForm.sms_enable_short_url = true;
          this.triggerForm.colly_template_id = null;
          this.triggerForm.sender_id = null;
        }

        this.templatesList = this.templatesCache[newVal] || [];
      },
    },
  },
  methods: {
    /**
     * Campos `field` permitidos para condiciones del trigger.
     * `call_duration` solo aplica cuando el canal origen es llamada/gestión telefónica: IVR, Bot o Humano (ids 3, 4, 5).
     */
    getConditionFieldOptionsForChannelId() {
      const items = [
        { text: 'Ventana de tiempo (dias)', value: TRIGGER_CONDITION_FIELD.timeWindow },
      ];
      const originId = Number(this.sourceChannelId);
      if ([3, 4, 5].includes(originId)) {
        items.push({ text: 'Duración llamada (seg)', value: TRIGGER_CONDITION_FIELD.callDuration });
      }
      return items;
    },
    emptyConditionRow() {
      return { field: null, operator: null, value: null };
    },
    addConditionRow() {
      this.triggerForm.conditions.push(this.emptyConditionRow());
    },
    removeConditionRow(index) {
      this.triggerForm.conditions.splice(index, 1);
      this.conditionTrashHoverIndex = null;
    },
    conditionFieldKey(field) {
      const k = canonicalTriggerConditionField(field);
      return k != null && k !== '' ? String(k) : 'none';
    },
    isTimeWindowConditionRow(condition) {
      return canonicalTriggerConditionField(condition && condition.field)
        === TRIGGER_CONDITION_FIELD.timeWindow;
    },
    onConditionRowFieldChange(index) {
      // Vuetify v-select puede emitir @change antes de que v-model actualice `field`.
      // Sin $nextTick, `time_window` quedaba con operator null y isConditionRowValid fallaba.
      this.$nextTick(() => {
        const row = this.triggerForm.conditions[index];
        if (!row) {
          return;
        }
        row.field = canonicalTriggerConditionField(row.field);
        row.value = null;
        if (row.field === TRIGGER_CONDITION_FIELD.timeWindow) {
          row.operator = TIME_WINDOW_OPERATOR;
        } else {
          row.operator = null;
        }
      });
    },
    /**
     * Opciones del primer select por fila: no se repite un `field` ya usado en otra fila.
     */
    conditionFieldsForRow(rowIndex) {
      const all = this.allConditionFieldOptionsForChannel;
      const row = this.triggerForm.conditions[rowIndex];
      const currentField = canonicalTriggerConditionField(row && row.field);
      const usedElsewhere = this.triggerForm.conditions
        .map((c, i) => {
          if (i === rowIndex) {
            return null;
          }
          return canonicalTriggerConditionField(c.field);
        })
        .filter(Boolean);
      return all.filter(opt => !usedElsewhere.includes(opt.value) || opt.value === currentField);
    },
    /** Hay tipo de condición elegido (v-model del select a veces entrega objeto ítem). */
    conditionRowHasField(condition) {
      return !!canonicalTriggerConditionField(condition && condition.field);
    },
    conditionValueHint(field) {
      const f = canonicalTriggerConditionField(field);
      if (f === TRIGGER_CONDITION_FIELD.callDuration) {
        return 'Valor en segundos (duración de llamada)';
      }
      if (f === TRIGGER_CONDITION_FIELD.timeWindow) {
        return 'Valor en días (ventana de tiempo)';
      }
      return '';
    },
    conditionTrashIconClassForRow(index) {
      if (this.conditionTrashHoverIndex === index && !this.disableButtons) {
        return 'k-orange-linear-text';
      }
      return 'grey--text text--darken-1';
    },
    allowedConditionFieldValuesForChannelId() {
      return this.getConditionFieldOptionsForChannelId().map(opt => opt.value);
    },
    syncConditionsToAllowedTypesForChannel() {
      const allowed = this.allowedConditionFieldValuesForChannelId();
      this.triggerForm.conditions = this.triggerForm.conditions.filter(
        c => !c.field || allowed.includes(canonicalTriggerConditionField(c.field)),
      );
    },
    /**
     * API → filas locales `{ field, operator, value }`.
     * Soporta: `{ items: [...] }`, objeto plano `{ time_window, call_duration }`, array legacy, campos planos en trigger.
     */
    normalizeConditionsFromTrigger(trigger) {
      const raw = trigger.conditions;

      if (raw && typeof raw === 'object' && !Array.isArray(raw) && Array.isArray(raw.items)) {
        return raw.items
          .map(item => ({
            field:    canonicalTriggerConditionField(item.field),
            operator: normalizedOperatorForConditionField(
              canonicalTriggerConditionField(item.field),
              item.operator,
            ),
            value:    item.value !== null && item.value !== undefined && item.value !== ''
              ? Number(item.value)
              : null,
          }))
          .filter(item => !!item.field);
      }

      if (raw && typeof raw === 'object' && !Array.isArray(raw) && !raw.items) {
        const o = raw;
        const rows = [];
        const tw = o[TRIGGER_CONDITION_FIELD.timeWindow];
        if (tw != null && tw !== '') {
          rows.push({
            field:    TRIGGER_CONDITION_FIELD.timeWindow,
            operator: TIME_WINDOW_OPERATOR,
            value:    Number(tw),
          });
        }
        const cd = o[TRIGGER_CONDITION_FIELD.callDuration];
        if (cd != null && cd !== '') {
          rows.push({
            field:    TRIGGER_CONDITION_FIELD.callDuration,
            operator: '>=',
            value:    Number(cd),
          });
        }
        return rows;
      }

      if (Array.isArray(raw) && raw.length) {
        return raw.map((c) => {
          const legacyType = c.condition_type || c.field;
          const f = canonicalTriggerConditionField(legacyType);
          let value = null;
          if (f === TRIGGER_CONDITION_FIELD.timeWindow) {
            value = c.condition_delay_minutes != null ? c.condition_delay_minutes : c.value;
          } else if (f === TRIGGER_CONDITION_FIELD.callDuration) {
            value = c.condition_voice_duration_seconds != null
              ? c.condition_voice_duration_seconds
              : c.value;
          } else {
            value = c.value;
          }
          return {
            field:    f,
            operator: normalizedOperatorForConditionField(f, c.operator),
            value:    value !== null && value !== undefined && value !== '' ? Number(value) : null,
          };
        }).filter(item => !!item.field);
      }

      if (trigger.condition_type) {
        const f = canonicalTriggerConditionField(trigger.condition_type);
        let value = null;
        if (f === TRIGGER_CONDITION_FIELD.timeWindow) {
          value = trigger.condition_delay_minutes;
        } else if (f === TRIGGER_CONDITION_FIELD.callDuration) {
          value = trigger.condition_voice_duration_seconds;
        } else {
          value = trigger.value;
        }
        return [{
          field:    f,
          operator: normalizedOperatorForConditionField(f, trigger.operator),
          value:    value !== null && value !== undefined && value !== '' ? Number(value) : null,
        }];
      }

      return [];
    },
    /**
     * Payload API: `{ items: [{ field, operator, value }] }`.
     * Sin filas válidas: `{}` — no se envía `conditions` en POST/PATCH.
     */
    buildConditionsObjectForApi() {
      const items = [];
      (this.triggerForm.conditions || []).forEach((row) => {
        if (!this.isConditionRowValid(row)) {
          return;
        }
        const field = canonicalTriggerConditionField(row.field);
        items.push({
          field,
          operator: field === TRIGGER_CONDITION_FIELD.timeWindow
            ? TIME_WINDOW_OPERATOR
            : row.operator,
          value:    Number(row.value),
        });
      });
      return items.length ? { items } : {};
    },
    /** Fila completa: field permitido para el canal, operador válido, entero ≥ 0. */
    isConditionRowValid(c) {
      const field = canonicalTriggerConditionField(c.field);
      if (!field) {
        return false;
      }
      const allowed = this.allowedConditionFieldValuesForChannelId();
      if (!allowed.includes(field)) {
        return false;
      }
      if (field === TRIGGER_CONDITION_FIELD.timeWindow) {
        if (c.operator !== TIME_WINDOW_OPERATOR) {
          return false;
        }
      } else if (!c.operator || !TRIGGER_CONDITION_OPERATOR_VALUES.includes(c.operator)) {
        return false;
      }
      const raw = c.value;
      const n = Number(raw);
      return raw !== null && raw !== undefined && raw !== ''
        && Number.isFinite(n) && n >= 0 && Number.isInteger(n);
    },
    /**
     * Carga todas las plantillas en paralelo al abrir el modal.
     * Se guardan en templatesCache por channel_id para no volver a pedirlas.
     */
    async fetchAllTemplates() {
      const [ivrTemplates, botTemplates, whatsappTemplates] = await Promise.all([
        this.axios.get('ivr_templates', { params: { paginate: 0, status: 'Activo' } })
          .then(({ data }) => data.map(item => ({ id: item.id, name: item.name })))
          .catch(() => []),
        this.axios.get('bot_templates', { params: { paginate: 0, status: 'Activo' } })
          .then(({ data }) => data.map(item => ({ id: item.id, name: item.name })))
          .catch(() => []),
        fetchWhatsappTemplatesForSelect(this.axios)
          .catch(() => []),
      ]);

      this.templatesCache = {
        3: ivrTemplates,
        4: botTemplates,
        7: whatsappTemplates,
      };

      // Si ya hay un canal seleccionado, mostrar sus plantillas
      if (this.triggerForm.channel_id) {
        this.templatesList = this.templatesCache[this.triggerForm.channel_id] || [];
      }
    },
    async fetchChannelStatuses() {
      this.channelStatuses = [];
      this.channelStatuses = await this.axios.get('/channel_statuses', {
        params: {
          channel_name: this.sourceChannelName,
        },
      })
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Error fetching channel statuses:', error);
        return [];
      });
    },
    getChannelById(channelId, field) {
      if (!channelId) {
        return null;
      }

      const channel = this.allChannels.find(c => Number(c.id) === Number(channelId));
      if (!channel) {
        return null;
      }
      return field ? channel[field] : channel;
    },
    getChannelByName(channelName, field) {
      if (!channelName) {
        return null;
      }

      const channel = this.allChannels.find(c => c.name === channelName);
      if (!channel) {
        return null;
      }
      return field ? channel[field] : channel;
    },
    saveTemplate(evt) {
      this.triggerForm.text = evt.text;
      this.triggerForm.subject = evt.subject;
      this.triggerForm.company_email_id = evt.company_email_id;
      this.triggerForm.sms_enable_short_url = evt.sms_enable_short_url;
      this.triggerForm.colly_template_id = evt.colly_template_id || null;
      this.triggerForm.sender_id = evt.colly_sender_id || null;
      this.showTemplateEditor = false;
    },
    saveWhatsappTemplate(evt) {
      this.triggerForm.template_id = null;
      this.triggerForm.colly_template_id = evt.colly_whatsapp_template_id || null;
      this.triggerForm.sender_id = evt.colly_whatsapp_sender_id || null;
      this.showWhatsappDialog = false;
    },
    async addTrigger() {
      if (this.sourceChannelId == null) {
        EventBus.$emit('error', 'Canal de origen no reconocido');
        return;
      }

      this.disableButtons = true;

      const conditionsPayload = this.buildConditionsObjectForApi();
      const triggerForm = {
        text:                   this.triggerForm.text,
        subject:                this.triggerForm.subject,
        template_id:            this.triggerForm.template_id,
        source_status_id:       this.triggerForm.status_id,
        company_email_id:       this.triggerForm.company_email_id,
        source_channel_id:      this.sourceChannelId,
        workflow_filter_id:     this.filter.id,
        sms_enable_short_url:   this.triggerForm.sms_enable_short_url,
        destination_channel_id: this.triggerForm.channel_id,
        conditions:             Object.keys(conditionsPayload).length > 0 ? conditionsPayload : null,
        force_delivery:    this.triggerForm.force_delivery,
        colly_template_id: this.triggerForm.colly_template_id,
        sender_id: this.triggerForm.sender_id,
      };

      const data = await this.axios.post('notification_triggers', triggerForm)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Error adding trigger:', error);
        return null;
      });

      if (!data) {
        this.disableButtons = false;
        EventBus.$emit('error', 'Error al agregar trigger');
        return;
      }

      // Refresh parent — preservar force_delivery del form (el API puede no devolverlo)
      const triggers = [...(this.filter.triggers || []), { ...data, force_delivery: this.triggerForm.force_delivery }];
      this.$emit('filter-updated', {
        ...this.filter,
        triggers,
      });

      // Refresh current rendered triggers (incl. conditions devueltas por el API)
      this.triggers.push({
        id:         data.id,
        text:       this.triggerForm.text,
        subject:    this.triggerForm.subject,
        status_id:  this.triggerForm.status_id,
        channel_id: this.triggerForm.channel_id,
        template_id:            this.triggerForm.template_id,
        company_email_id:     this.triggerForm.company_email_id,
        sms_enable_short_url: this.triggerForm.sms_enable_short_url,
        conditions: this.normalizeConditionsFromTrigger(data),
        force_delivery: this.triggerForm.force_delivery,
        colly_template_id: this.triggerForm.colly_template_id,
        sender_id: this.triggerForm.sender_id,
      });

      this.resetForm();
      this.disableButtons = false;
    },
    async removeTrigger(triggerId) {
      this.disableButtons = true;

      const result = await this.axios.delete(`notification_triggers/${triggerId}`)
      .then(() => true)
      .catch((error) => {
        console.error('Error removing trigger:', error);
        return null;
      });

      if (!result) {
        this.disableButtons = false;
        EventBus.$emit('error', 'Error al eliminar trigger');
        return;
      }

      // Refresh parent
      const triggers = (this.filter.triggers || []).filter(trigger => trigger.id !== triggerId);
      this.$emit('filter-updated', {
        ...this.filter,
        triggers,
      });

      // Removes from current rendered triggers
      this.triggers = this.triggers.filter(trigger => trigger.id !== triggerId);

      this.disableButtons = false;
    },
    editTrigger(trigger) {
      this.editingTriggerId = trigger.id;
      const picked = _.pick(trigger, Object.keys(this.emptyTriggerForm));
      this.triggerForm = {
        ...this.emptyTriggerForm,
        ...picked,
        conditions: this.normalizeConditionsFromTrigger(trigger),
        force_delivery: this.normalizeForceDelivery(trigger.force_delivery),
      };
    },
    /**
     * Normaliza force_delivery a entero (1 o 0) para compatibilidad
     * con Vuetify 1.0.x radio buttons y con la DB.
     */
    normalizeForceDelivery(value) {
      if (value === undefined || value === null) {
        return 0;
      }
      return value ? 1 : 0;
    },
    stopEditing() {
      this.editingTriggerId = null;
      this.resetForm();
    },
    async updateTrigger() {
      if (this.sourceChannelId == null) {
        EventBus.$emit('error', 'Canal de origen no reconocido');
        return;
      }

      this.disableButtons = true;

      const conditionsPayload = this.buildConditionsObjectForApi();
      const triggerForm = {
        text:                   this.triggerForm.text,
        subject:                this.triggerForm.subject,
        template_id:            this.triggerForm.template_id,
        source_status_id:       this.triggerForm.status_id,
        company_email_id:       this.triggerForm.company_email_id,
        source_channel_id:      this.sourceChannelId,
        workflow_filter_id:     this.filter.id,
        sms_enable_short_url:   this.triggerForm.sms_enable_short_url,
        destination_channel_id: this.triggerForm.channel_id,
        conditions:             Object.keys(conditionsPayload).length > 0 ? conditionsPayload : null,
        force_delivery:    this.triggerForm.force_delivery,
        colly_template_id: this.triggerForm.colly_template_id,
        sender_id: this.triggerForm.sender_id,
      };

      const result = await this.axios.patch(`notification_triggers/${this.editingTriggerId}`, triggerForm)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Error updating trigger:', error);
        return null;
      });

      if (!result) {
        this.disableButtons = false;
        EventBus.$emit('error', 'Error al actualizar trigger');
        return;
      }

      // Refresh parent — preservar force_delivery del form (el API puede no devolverlo)
      const triggers = [...(this.filter.triggers || [])];
      const index = triggers.findIndex(trigger => trigger.id === this.editingTriggerId);
      if (index !== -1) {
        triggers[index] = { ...result, force_delivery: this.triggerForm.force_delivery };
      }
      this.$emit('filter-updated', {
        ...this.filter,
        triggers,
      });

      // Refresh current rendered triggers con conditions del response
      const index2 = this.triggers.findIndex(trigger => trigger.id === this.editingTriggerId);
      this.$set(this.triggers, index2, {
        ...this.triggerForm,
        id: this.editingTriggerId,
        conditions: this.normalizeConditionsFromTrigger(result),
      });

      // Reset form
      this.disableButtons = false;
      this.editingTriggerId = null;
      this.resetForm();
    },
    resetForm() {
      this.triggerForm = { ...this.emptyTriggerForm, conditions: [] };
      this.conditionTrashHoverIndex = null;
    },
  },
};
</script>

<style scoped>
.border-radius-10 {
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #ddd;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-pointer input {
  cursor: pointer !important;
}

.trigger-modal {
  height: 85vh;
  display: flex;
  flex-direction: column;
}

.add-condition-btn {
  width: auto !important;
  min-width: 32px !important;
  max-width: 70px !important;
  height: 32px !important;
  border-radius: 999px !important;
  padding: 0 10px !important;
  flex: 0 0 auto !important;
}

.condition-editor-row {
  width: 100%;
}

.condition-editor-fields {
  min-width: 0;
}

.condition-trash-col {
  flex: 0 0 auto;
}

.condition-trash-btn >>> .condition-trash-icon {
  transition: color 0.2s ease;
}

/* Texto largo en selects de condición: una línea con puntos suspensivos (Vuetify 1) */
.condition-select-truncate >>> .input-group__input {
  min-width: 0;
  overflow: hidden;
}

.condition-select-truncate >>> .input-group__selections {
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}

.condition-select-truncate >>> .input-group__selections__comma {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.condition-value-field >>> .input-group {
  min-width: 0;
}

.condition-value-field >>> .input-group__details {
  overflow: hidden;
  max-width: 100%;
}

.condition-value-field >>> .input-group__details .input-group__messages {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowDetail/TriggersModal.vue